export function generateUniqueCode() {
    const currentDate = new Date()
    const randomNumber = Math.floor(Math.random() * 10000)
    const formattedDate = currentDate.toISOString().replace(/[-:]/g, '').slice(0, 14)
    const uniqueCode = formattedDate + randomNumber.toString().padStart(4, '0')
    return uniqueCode ?? 'unique'
}
